<script lang="ts">
  let {
    kind = 'info',
    text,
    actionLabel,
    onaction,
  }: {
    kind?: 'info' | 'warn';
    text: string;
    actionLabel?: string;
    onaction?: () => void;
  } = $props();
</script>

<div class="banner {kind}">
  <span>{text}</span>
  {#if actionLabel !== undefined && onaction !== undefined}
    <button onclick={onaction}>{actionLabel}</button>
  {/if}
</div>

<style>
  .banner {
    margin: 8px 12px;
    padding: 10px 14px;
    border-radius: var(--radius);
    font-size: 14px;
    display: flex;
    gap: 12px;
    align-items: center;
    justify-content: space-between;
  }
  .info {
    background: var(--surface-2);
    color: var(--ink);
  }
  .warn {
    background: var(--warn-bg);
    color: var(--warn-ink);
  }
  button {
    border: 0;
    background: transparent;
    color: var(--brand);
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
  }
  .warn button {
    color: inherit;
    text-decoration: underline;
  }
</style>
